import {
    UPDATE_LISTINGS_UGC,
    UPDATE_GALLERY_REVIEWS_UGC,
    FETCH_UGC,
    TOGGLE_UGC_VIEW
} from '../../actions/ugc';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { getUgcTranslatedMilestones } from './utils';

const ugcReducer = (ugcMap = {}) => {

    const initialState = {
        ugcMap,
        showOriginal: true
    };

    return (state = initialState, action = {}) => {
        const { type, data } = action;

        switch (type) {
            case UPDATE_LISTINGS_UGC:
                return {
                    ...state,
                    ugcMap: {
                        ...state.ugcMap,
                        original: addListingsUGC({
                            original: state.ugcMap.original,
                            listingsUGC: data.listingsUGC,
                            carouselType: data.carouselType
                        })
                    }
                };
            case UPDATE_GALLERY_REVIEWS_UGC:
                return {
                    ...state,
                    ugcMap: {
                        ...state.ugcMap,
                        original: addGalleryReviewsUGC({
                            original: state.ugcMap.original,
                            review: data.review
                        })
                    }
                };
            case TOGGLE_UGC_VIEW:
                return {
                    ...state,
                    showOriginal: !state.showOriginal
                };
            case FETCH_UGC:
                return {
                    showOriginal: data.shouldToggle ? !data.translatedUGC : state.showOriginal,
                    ugcMap: {
                        ...state.ugcMap,
                        translated: data.translatedUGC
                    }
                };
            default:
                return state;
        }
    };
};

const addListingsUGC = ({ original, listingsUGC, carouselType }) => {
    const listings = { ...original.listings };
    listings[carouselType] = listingsUGC;

    return {
        ...original,
        listings
    };
};

const addGalleryReviewsUGC = ({ original, review }) => {
    const galleryReviews = { ...original.galleryReviews };
    galleryReviews[review.id] = review.text;

    return {
        ...original,
        galleryReviews
    };
};

// Selectors

/**
 * Get work process with the ugc translations
 * @param {object} state redux state
 * @param {object} workProcess work process object before ugc translation
 * @return {object} work process object with ugc translation
 */
export const getTranslatedMilestones =({ ugc, workProcess }) => {
    const { workProcess: currentWorkProcessUGC = {} } = getCurrentContent({ ugc });

    return getUgcTranslatedMilestones({ workProcess, currentWorkProcessUGC });
};

// End of selectors

export default ugcReducer;
